module.exports = __webpack_public_path__ + "media/images/athletes/291-2af6ef449113ecd03d8426293461d92b.png";